import React from 'react';
import {useData} from "../../DataContext/DataProvider"

function PlannerElementSmol({ elementDate }) {
    const dataContext = useData();
    
    const plans = dataContext.planData.plans.filter((plan) => new Date(plan.Plan_Date).getTime() === new Date(elementDate).getTime())
    
    return (
        <div>
            <p>{elementDate?.toLocaleDateString('default', { day: 'numeric' })}</p>
            <ul>
                {plans?.map((element, index) => {
                    return (
                        <li key={index}>
                            {element.Recipe_Name}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default PlannerElementSmol;